import { Button } from "./ui/button";
import { FileDown } from "lucide-react";

const ExportPDF = ({ title, contentRef }) => {
  const handlePrint = () => {
    // Add print-specific styles
    const printStyles = `
      @media print {
        body * {
          visibility: hidden;
        }
        .print-content, .print-content * {
          visibility: visible;
        }
        .print-content {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          padding: 20px;
        }
        .no-print {
          display: none !important;
        }
        @page {
          size: A4;
          margin: 20mm;
        }
      }
    `;

    // Create style element
    const styleElement = document.createElement('style');
    styleElement.innerHTML = printStyles;
    document.head.appendChild(styleElement);

    // Mark content for printing
    if (contentRef?.current) {
      contentRef.current.classList.add('print-content');
    }

    // Trigger print
    window.print();

    // Cleanup
    setTimeout(() => {
      document.head.removeChild(styleElement);
      if (contentRef?.current) {
        contentRef.current.classList.remove('print-content');
      }
    }, 100);
  };

  return (
    <Button
      variant="outline"
      onClick={handlePrint}
      className="gap-2 no-print"
      data-testid="export-pdf-btn"
    >
      <FileDown className="w-4 h-4" />
      Exporter PDF
    </Button>
  );
};

export default ExportPDF;
